import { PaymentMethod } from "~/payments";

// tslint:disable:object-literal-sort-keys
const defaultShopConfig = {
  autoRender: true,
  brandName: "Grandado",
  language: "nl",
  brandColor: {
    primary: "#f05c67",
    secondary: "#f05c67"
  },
  supportAssetsBaseUrl:
    process.env.NODE_ENV === "production"
      ? "https://support-center.jsbv.app"
      : "",
  webshop: "grandado-nl",
  platform: "nexus",
  organization: "mediapress",
  organizationPhoneNumber: undefined,
  b2bEmailAddress: "b2b@mediapress.com.hk",
  paymentMethods: [PaymentMethod.MASTER_VISA],
  integrations: [] as any
};

type IShopConfig = typeof defaultShopConfig;

export const shopConfig: IShopConfig = {
  ...defaultShopConfig,
  ...(window as any).__scShopConfig
};



// WEBPACK FOOTER //
// ./src/helpers/shopConfig.ts